import api from "@/api/api-v2-config";

export async function getRawMaterialListAxios() {    
    return await api.get("rawmaterials?pageNumber=1&pageSize=10000");
}

export async function getRawMaterialListByIdAxios(id){
    return await api.get("rawmaterials/"+id);
}

export async function deleteRawMaterialAxios(id) {    
    return await api.delete("rawmaterials?Id=" + id);
}

export async function postRawMaterialAxios(rawmaterials) {    
    return await api.post("rawmaterials", rawmaterials);
}

export async function putRawMaterialAxios(rawmaterials) {    
    return await api.put("rawmaterials", rawmaterials);
}


export async function getRawMaterialDocumentList(ReferenceID) {
    return await api.get(`rawmaterials/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}


export async function deleteRawMaterialDocument(id) {
    return await api.delete("rawmaterials/files/" + id);
}

export async function uploadRawMaterialDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('rawmaterials/files/upload', formData);
}

export async function uploadRawMaterialMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('rawmaterials/files/uploads', formData);
}


export async function downloadRawMaterialDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("rawmaterials/files/download/" + id);
}